import { render, staticRenderFns } from "./page-setting-mail-i.vue?vue&type=template&id=6fd99fd7&scoped=true"
import script from "./page-setting-mail-i.vue?vue&type=script&lang=js"
export * from "./page-setting-mail-i.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd99fd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd99fd7')) {
      api.createRecord('6fd99fd7', component.options)
    } else {
      api.reload('6fd99fd7', component.options)
    }
    module.hot.accept("./page-setting-mail-i.vue?vue&type=template&id=6fd99fd7&scoped=true", function () {
      api.rerender('6fd99fd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/page-setting-mail-i.vue"
export default component.exports